import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// core
import { API } from "../../core/api";

// components
import { Form, Input, Select, Button, Divider } from "antd";
import { SellerProduct } from "./SellerProduct";
import { Loading } from "../../components/Loading";
import { Note } from "../Note";

const { Option } = Select;

export const SellerProducts = (props) => {
  const params = useParams();
  const [sellerProducts, setSellerProducts] = useState([]);
  const [cities, setCities] = useState([]);
  const [seller, setSeller] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [sellerProductSection, setSellerProductSection] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setPageIsLoading] = useState(false);

  const getSellerProducts = () => {
    setPageIsLoading(true);
    // API.get
    //   .seller_products(params.id, props.site.id)
    //   .then((response) => {
    //     if (response.success) {
    //       setSellerProducts(response.data);
    //       setPageIsLoading(false);
    //     } else {
    //       Note.error(response.message);
    //       setPageIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setPageIsLoading(false);
    //   });
  };

  const getSellers = () => {
    // API.get
    //   .sellers(params.id, props.site.id)
    //   .then((response) => {
    //     if (response.success) {
    //       setSellers(response.data);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const getCities = (seller_id) => {
    setIsLoading(true);
    // API.get
    //   .cities(params.id, seller_id, props.site.id)
    //   .then((response) => {
    //     if (response.success) {
    //       setCities(response.data);
    //       setIsLoading(false);
    //     } else {
    //       Note.error(response.message);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoading(false);
    //   });
  };

  const addSellerProduct = (values) => {
    setIsLoading(true);
    // API.post
    //   .seller_product({
    //     product_id: params.id,
    //     site_id: props.site.id,
    //     ...values,
    //   })
    //   .then((response) => {
    //     if (response.success) {
    //       setSellerProductSection(false);
    //       Note.success(response.message);
    //       setIsLoading(false);
    //       getSellerProducts();
    //     } else {
    //       Note.error(response.message);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoading(false);
    //   });
  };

  const sellerChanged = (value) => {
    getCities(value);
    setSeller(value);
  };

  useEffect(() => {
    getSellers();
    getSellerProducts();
    // eslint-disable-next-line
  }, []);

  const addForm = () => {
    return (
      <Loading isLoading={isLoading}>
        <Form
          className="flex-row flex-content-space-between flex-items-center flex-wrap -mt-10"
          name="sellerProductAddForm"
          onFinish={addSellerProduct}
          requiredMark={false}
          scrollToFirstError
        >
          <Form.Item
            className="min-w-250px w-25 sm:w-100 pt-10"
            name="seller_id"
            label="فروشنده"
            colon={false}
            rules={[
              {
                required: true,
                message: "انتخاب فروشنده الزامی است.",
              },
            ]}
          >
            <Select
              className="border-black"
              showSearch
              optionFilterProp="name"
              value={seller}
              onChange={sellerChanged}
            >
              {sellers.map((seller) => (
                <Option value={seller.id} name={seller.name}>
                  {seller.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {seller && cities.length > 0 ? (
            <Form.Item
              className="min-w-250px w-25 sm:w-100 pt-10"
              name="city_id"
              label="شهر"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "انتخاب شهر الزامی است.",
                },
              ]}
            >
              <Select
                className="border-black"
                showSearch
                optionFilterProp="name"
              >
                {cities.map((city) => (
                  <Option value={city.id} name={city.name}>
                    <small className="color-promotion-s1">
                      [{city.province.name}]
                    </small>{" "}
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          ) : null}
          {seller && cities.length > 0 ? (
            <Form.Item
              className="min-w-250px w-25 sm:w-100 pt-10"
              name="price"
              label="قیمت"
              colon={false}
              rules={[{ required: true, message: "قیمت کالا الزامی است." }]}
            >
              <Input
                className="input-black border-black text-left"
                suffix="ریال"
              />
            </Form.Item>
          ) : null}
          {seller && cities.length <= 0 ? (
            <div className="color-red pt-10">
              شهری با قابلیت اضافه کردن این کالا یافت نشد
            </div>
          ) : null}
          <div className="w-20 sm:w-100 pt-10">
            <div className="flex-row flex-items-center flex-content-end w-100">
              <Form.Item
                className={`${!seller || cities.length <= 0 ? "sm:w-100" : ""}`}
              >
                <Button
                  className={`button-red ${
                    !seller || cities.length <= 0 ? "sm:w-100" : ""
                  }`}
                  onClick={(e) => {
                    setSeller(null);
                    setSellerProductSection(false);
                  }}
                >
                  <i className="far fa-times"></i>
                </Button>
              </Form.Item>
              {seller && cities.length > 0 ? (
                <Form.Item className="w-100 pr-15">
                  <Button className="button-promotion w-100" htmlType="submit">
                    ذخیره
                  </Button>
                </Form.Item>
              ) : null}
            </div>
          </div>
        </Form>
        <p className="mt-15 color-orange">
          <small>کالا در شهر بصورت غیرفعال اضافه خواهد شد.</small>
        </p>
        <p className="-mt-15 color-orange">
          <small>
            تخفیف و سایر مشخصات کالا در شهر بعد از افزودن شهر قابل تغییر است.
          </small>
        </p>
      </Loading>
    );
  };

  return (
    <Loading isLoading={isPageLoading}>
      <div className="seller-products">
        {sellerProductSection ? (
          addForm()
        ) : (
          <div className="flex-row flex-content-space-between flex-items-center">
            <div>تعداد شهرها: {sellerProducts.length}</div>
            {sellers.length > 0 ? (
              <Button
                className="button-secondary"
                onClick={(e) => setSellerProductSection(true)}
              >
                افزودن شهر
              </Button>
            ) : (
              <small>کالا فروشنده ندارد</small>
            )}
          </div>
        )}
        <Divider />
        {sellerProducts?.map((sellerProduct) => (
          <SellerProduct sellerProduct={sellerProduct} unit={props.unit} />
        ))}
      </div>
    </Loading>
  );
};
